import React, { Component } from 'react'
import moment from 'moment';
import config from "../../../config";
import { Datos_Empresa, development } from "../../../libs/utils/Const";


class Stocks extends Component {

    render() {
        const { ReportsModel, DocsToPrint } = this.props;
        const arrayResponse = (DocsToPrint && DocsToPrint[0]) ? DocsToPrint[0].finalArrayResponse : [];
        const _user = JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser'));
        const today = moment(new Date()).format('MM/DD/YYYY');
       
        return (
            <>
                <table><tr><td>

                    <div style={{ height: "auto", width: "90%", marginLeft: "auto", marginRight: "auto", marginTop: "2.5vw" }}>
                        <div className="row">
                            <div className="col-3">
                                <img src={development? require('../../../images/logo_draft.svg') : require('../../../images/logo_EMPRESA.svg')} alt="Logo" />
                                <p className="text-center">{Datos_Empresa.Nombre} {Datos_Empresa.Sociedad}<br /></p>
                            </div>
                            <div className="col-6 text-center">
                                <h5><strong>INFORME DE EXISTENCIAS</strong></h5>
                            </div>
                            <div className="col-3">
                                <span className="text-left">Sucursal:</span>
                                <p>CÓDIGO ALMACÉN: <strong>{ReportsModel.WhsCode ?? ''}</strong> <br />FECHA: {today ?? ''} <br />USUARIO: {_user?.USERID ?? ''} .- {_user?.U_NAME ?? ''}</p>
                            </div>
                        </div>

                        <div className='row mt-5' style={{ paddingRight: "15px" }}>
                            <div className='col-6 text-left'>
                                <h6><strong>Stock existencias</strong></h6>
                            </div>

                            <div className='col-12'>

                                {/*ReportsModel.checkExistDate*/ true &&
                                    <>
                                        <h6>Entradas de proveedor</h6>
                                        {arrayResponse.map((row) => {
                                            return (
                                                <>
                                                    <div className='col-6 text-right'>
                                                        <h6>Fecha: {moment(row.Date).format('MM/DD/YYYY')}</h6>
                                                    </div>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th className="text-left">Código</th>
                                                                <th className="text-left">Descripción</th>
                                                                <th className="text-left">Grupo</th>
                                                                <th className="text-center">Existencia</th>
                                                                <th className="text-center">Stock físico</th>
                                                            </tr>
                                                            {/* <tr >
                                                                <td className="text-left" colSpan={5} style={{ background: "#dee2e6" }}>{row.Line ?? ''}</td>
                                                            </tr> */}
                                                        </thead>
                                                        {row.rows.map((rowLine, index) => {
                                                            return (
                                                                <tbody >

                                                                    <tr style={{ fontSize: '12px', borderBottom: "solid 1px" }}>
                                                                        <td className="text-left">{rowLine.ItemCode ?? ''}</td>
                                                                        <td className="text-left">{rowLine.ItemName ?? ''}</td>
                                                                        <td className="text-left">{rowLine.ItmsGrpNam ?? ''}</td>
                                                                        <td className="text-center">{Number(rowLine.OnHand).toFixed(2) ?? ''}</td>
                                                                        {/* <td className="text-center">{Number(rowLine.OnOrder).toFixed(2) ?? ''}</td> */}
                                                                        <td className="text-center">{''}</td>
                                                                    </tr>

                                                                </tbody>
                                                            )
                                                        })}
                                                    </table>


                                                </>
                                            )
                                        })}

                                    </>
                                }
                            </div>
                        </div>

                    </div>

                </td></tr></table>
            </>
        )
    }
}

export default Stocks